import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PluginListComponent } from './list/plugins.component';
import { AuthGuard } from '../auth/auth.guard';
import { ThemeResolver } from '../../theme/theme.resolver';

const routes: Routes = [
  {
    path: 'plugins',
    component: PluginListComponent,
    canActivate: [AuthGuard],
    resolve: { theme: ThemeResolver }
  }
];

export const router: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/modules/plugins/plugins.routes.ts